<template>
  <b-card>

    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Username"
            label-for="account-username"
          >
            <b-form-input
              v-model="user.login"
              placeholder="Username"
              readonly
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Name"
            label-for="account-name"
          >
            <b-form-input
              v-model="user.name"
              placeholder="Name"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="E-mail"
            label-for="account-e-mail"
          >
            <b-form-input
              v-model="user.email"
              :state="!$v.user.email.$invalid"
              placeholder="Email"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Company"
            label-for="account-company"
          >
            <b-form-input
              v-model="user.company"
              name="company"
              placeholder="Company name"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Phone"
            label-for="account-phone"
          >
            <b-form-input
              v-model="user.phone"
              placeholder="Phone Number"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="save"
          >
            Save changes
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import api from '@/libs/axios'
import { required, email } from 'vuelidate/lib/validators'
import { hmError, hmSuccess } from '@/libs/toastification'
import { ObjectAssign } from '@/libs/helpers'

export default {
  props: {
    userData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      user: {
        login: null,
        email: null,
        name: null,
        company: null,
        phone: null
      }
    }
  },
  validations: {
    user: {
      login: { required },
      email: { required, email }
    }
  },
  methods: {
    save() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      api.post('/api/matomo/user/update', { user: this.user }).then(r => {
        if (r.data.code !== 'Ok') {
          if (r.data.code.indexOf('ExceptionEmailExists') !== -1) {
            return hmError('The email is being used')
          }
          return hmError('Error saving user information')
        }
        hmSuccess('Operation was successful')
      }).catch(e => {
        hmError('Error saving user information')
        console.error(e)
      })
    }
  },
  mounted() {
    api.post('/api/matomo/user/current', { login: this.userData.login }).then(r => {
      if (r.data.code !== 'Ok') return hmError('Error reading data')
      ObjectAssign(this.user, r.data.user)
    })
  }
}
</script>
